import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChannelsService } from '@app/services/channels.service';
import { OperatorsService } from '@app/services/operators.service';
import { SharedService } from '@app/services/shared.service';
import { UserService } from '@app/services/user.service';
import { SharedModalComponent } from '@shared/components/modal/modal.component';
import { IChannel } from 'libs/shared/src/lib/interfaces';

@Component({
  selector: 'blu-select-operator',
  templateUrl: './select-operator.component.html',
  styleUrls: ['./select-operator.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [SharedModalComponent],
})
export class SelectOperatorComponent implements OnInit {
  channel?: IChannel;
  selectedOperatorIds: string[] = [];
  loading = true;
  saving = false;

  constructor(
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public operatorListService: OperatorsService,
    public userService: UserService,
    public channelsService: ChannelsService,
  ) {}

  async ngOnInit() {
    try {
      const id = this.route.snapshot.paramMap.get('id');
      if (!id) return;

      const orgId = this.userService.organization()?.uid;
      if (!orgId) return;

      await Promise.all([
        this.getChannel(id),
        this.operatorListService.getOperators(orgId),
      ]);
    } finally {
      this.loading = false;
    }
  }

  private async getChannel(id: string): Promise<void> {
    const channel = await this.channelsService.getChannel(id);
    if (!channel) return;
    this.channel = channel;
    if (this.channel.operators) {
      this.selectedOperatorIds = [...this.channel.operators];
    }
  }

  selectOperator(operatorId: string) {
    const index = this.selectedOperatorIds.indexOf(operatorId);
    if (index !== -1) {
      this.selectedOperatorIds.splice(index, 1);
    } else {
      this.selectedOperatorIds.push(operatorId);
    }
  }

  async save(): Promise<void> {
    if (!this.channel?.uid) return;
    try {
      this.saving = true;
      await this.channelsService.updateChannel(this.channel.uid, {
        operators: this.selectedOperatorIds,
      });
      this.sharedService.closeModal(this.route);
    } catch (error) {
      console.error('Error updating channel operators:', error);
    } finally {
      this.saving = false;
    }
  }
}
